
<div class="card">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-sm-10">
        <p class="text-muted text-uppercase fw-semibold">LPC Availability</p>

      </div>
      <div class="col-sm-1" style="top: -2%;width: 2%;">
        @if (isLoading) {
          <span class="pageLoader">
            <div class="loading-spinner"></div>
          </span>
        }
      </div>
      <div class="col-sm-2" style="display: inline-block;width: 14%;padding-right: 0px;">
        <span style="float: right;"><p-calendar [(ngModel)]="date" [showTransitionOptions]="'1ms'"
        (onSelect)="onAvailabilityChange($event)" [showIcon]="true"></p-calendar></span>
      </div>
    </div>

    <div class="app-calendar">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>


<p-dialog [(visible)]="usersDialog" [resizable]="false" [draggable]="false" [style]="{width: '80%'}" [header]="title"
  [modal]="true" styleClass="p-fluid">
  <p-table #dt [(value)]="tkUsers" dataKey="id" [scrollable]="true" scrollDirection="both" scrollHeight="150px"
    styleClass="p-datatable-users" responsiveLayout="scroll" rows="5" [rowHover]="true" class="insidetable"
    [loading]="loadingTKData" responsiveLayout="scroll">

    <ng-template pTemplate="header">
      <tr>
        <th style="padding: 1rem 1rem !important;">First Name</th>
        <th >Last Name</th>
        <th>Email</th>
        <th>TK Practice Area</th>
        <th>Total Available Time</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tk let-columns="columns">
      <tr>
        <td style="padding: 1rem 1rem !important;">
          {{tk.userDetails['firstName']}}
        </td>
        <td>
          {{tk.userDetails['lastName']}}
        </td>

        <td>
          {{tk.userDetails['mainEmail']}}
        </td>
        <td>
          {{tk.userDetails['tkPracticeArea'] ?tk.userDetails['tkPracticeArea']:"-"}}
        </td>
        <td>
          {{tk['dailyTime'] | minutesToTime}}
        </td>

      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4" style="padding: 3rem !important;">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>